// CSS Modules - component class name: OrderForm__

<template>
  <form v-if="!showThankyou" :class="$style.container">
    <div class="columns">
      <div class="column">
        <FormSelect
          v-model.trim="$v.formData.fair.$model"
          :label="config.labels.fair.label"
          :errorMessage="config.labels.fair.errorMessage"
          :error="$v.formData.fair.$error && $v.$dirty && isSubmitted"
          :options="selectOptionsPlain"
          :initialOption="initialValue"
          :disabled="false"
        />
      </div>
    </div>
    <div class="columns" v-if="!currentFair.minimized">
      <div class="column">
        <FormInput
          v-model.trim="$v.formData.company.$model"
          :label="config.labels.company.label"
          :boldLabel="true"
          :errorMessage="config.labels.company.errorMessage"
          :error="$v.formData.company.$error && $v.$dirty && isSubmitted"
          :originalValue="
            previousData.company && previousData.company !== ''
              ? previousData.company
              : null
          "
          :formSubmitSwitch="formSubmitSwitch"
        />
      </div>
      <div class="column">
        <FormInput
          v-model.trim="$v.formData.department.$model"
          :label="config.labels.department.label"
          :boldLabel="true"
          :errorMessage="config.labels.department.errorMessage"
          :error="$v.formData.department.$error && $v.$dirty && isSubmitted"
          :originalValue="
            previousData.department && previousData.department !== ''
              ? previousData.department
              : null
          "
          :formSubmitSwitch="formSubmitSwitch"
        />
      </div>
    </div>
    <div class="columns" v-if="!currentFair.minimized">
      <div class="column">
        <FormInput
          v-model.trim="$v.formData.streetNr.$model"
          :label="config.labels.streetNr.label"
          :boldLabel="true"
          :errorMessage="config.labels.streetNr.errorMessage"
          :error="$v.formData.streetNr.$error && $v.$dirty && isSubmitted"
          :originalValue="
            previousData.streetNr && previousData.streetNr !== ''
              ? previousData.streetNr
              : null
          "
          :formSubmitSwitch="formSubmitSwitch"
        />
      </div>
      <div class="column">
        <FormInput
          v-model.trim="$v.formData.zipCity.$model"
          :label="config.labels.zipCity.label"
          :boldLabel="true"
          :errorMessage="config.labels.zipCity.errorMessage"
          :error="$v.formData.zipCity.$error && $v.$dirty && isSubmitted"
          :originalValue="
            previousData.zipCity && previousData.zipCity !== ''
              ? previousData.zipCity
              : null
          "
          :formSubmitSwitch="formSubmitSwitch"
        />
      </div>
    </div>
    <div class="columns" v-if="!currentFair.minimized">
      <div class="column">
        <FormInput
          v-model="formData.phone"
          :label="config.labels.phone.label"
          :optionalLabel="config.labels.phone.optionLabel"
          :error="false"
          :originalValue="
            previousData.phone && previousData.phone !== ''
              ? previousData.phone
              : null
          "
          :formSubmitSwitch="formSubmitSwitch"
        />
      </div>
      <div class="column">
        <FormInput
          v-model="formData.fax"
          :label="config.labels.fax.label"
          :optionalLabel="config.labels.fax.optionLabel"
          :error="false"
          :originalValue="
            previousData.fax && previousData.fax !== ''
              ? previousData.fax
              : null
          "
          :formSubmitSwitch="formSubmitSwitch"
        />
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <FormInput
          v-model.trim="$v.formData.email.$model"
          :label="config.labels.email.label"
          :boldLabel="true"
          :errorMessage="config.labels.email.errorMessage"
          :error="$v.formData.email.$error && $v.$dirty && isSubmitted"
          :originalValue="
            previousData.email && previousData.email !== ''
              ? previousData.email
              : null
          "
          :formSubmitSwitch="formSubmitSwitch"
        />
      </div>
      <div class="column"></div>
    </div>
    <div class="columns">
      <div class="column">
        <FormInput
          v-model.trim="$v.formData.numberOfTickets.$model"
          :label="config.labels.numberOfTickets.label"
          :boldLabel="true"
          :errorMessage="config.labels.numberOfTickets.errorMessage"
          :error="
            $v.formData.numberOfTickets.$error && $v.$dirty && isSubmitted
          "
          :originalValue="
            previousData.numberOfTickets && previousData.numberOfTickets !== ''
              ? previousData.numberOfTickets
              : null
          "
          :formSubmitSwitch="formSubmitSwitch"
        />
      </div>
      <div class="column"></div>
    </div>
    <div class="columns" v-if="!currentFair.minimized">
      <div class="column">
        <FormTextarea
          v-model.trim="$v.formData.recipients.$model"
          :label="config.labels.recipients.label"
          :errorMessage="config.labels.recipients.errorMessage"
          :error="$v.formData.recipients.$error && $v.$dirty && isSubmitted"
          :rows="5"
          :columns="20"
        />
      </div>
      <div class="column">
        <FormTextarea
          v-model.trim="formData.remarks"
          :label="config.labels.remarks.label"
          :optionalLabel="config.labels.fax.optionLabel"
          :rows="5"
          :columns="20"
        />
      </div>
    </div>
    <div class="columns">
      <div class="column has-text-right-tablet">
        <Button
          colour="blue"
          text="Senden"
          type="submit"
          :isForm="true"
          @close="handleSubmit"
        >
        </Button>
      </div>
    </div>
    <div :class="$style.serverError" v-if="serverError">
      {{ config.serverErrorMessage }}
    </div>
    <ReCaptcha :executeSwitch="executeSwitch" :submit="submit" />
  </form>
</template>

<script>
import { email, numeric, required } from "vuelidate/lib/validators";
import ReCaptcha from "../ReCaptcha/ReCaptcha";
import FormInput from "../FormInput/FormInput";
import FormSelect from "../FormSelect/FormSelect";
import FormTextarea from "../FormTextarea/FormTextarea";
import Button from "../Button/Button";
import axios from "axios";

export default {
  name: "OrderForm",
  components: {
    ReCaptcha,
    Button,
    FormInput,
    FormSelect,
    FormTextarea
  },
  props: {
    config: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      formData: {
        fair: "",
        company: "",
        department: "",
        streetNr: "",
        zipCity: "",
        phone: "",
        fax: "",
        email: "",
        numberOfTickets: "",
        recipients: "",
        remarks: "",
        domain: "",
        pageUrl: "",
        token: ""
      },
      previousData: {},
      isSubmitted: false,
      formSubmitSwitch: false,
      executeSwitch: false,
      showThankyou: false,
      serverError: false,
      currentFair: {}
    };
  },
  validations() {
    if (this.currentFair && !this.currentFair.minimized) {
      return {
        formData: {
          fair: {
            required
          },
          company: {
            required
          },
          department: {
            required
          },
          streetNr: {
            required
          },
          zipCity: {
            required
          },
          email: {
            required,
            email
          },
          numberOfTickets: {
            required,
            numeric
          },
          recipients: {
            required
          }
        }
      }
    } else {
      return {
        formData: {
          fair: {
            required
          },
          email: {
            required,
            email
          },
          numberOfTickets: {
            required,
            numeric
          }
        }
      }
    }
  },
  computed: {
    initialValue: function() {
      let value = "";
      let fairId = this.getParameter("fair");
      if (!fairId && this.config.initialSelectOption) {
        fairId = this.config.initialSelectOption;
      }
      if (fairId) {
        const preset = this.config.selectOptions.find(function(obj) {
          return obj.id == fairId;
        });
        if (preset) {
          value = preset.name;
        } else {
          value = this.config.selectOptions[0].name;
        }
      } else {
        value = this.config.selectOptions[0].name;
      }
      return value;
    },
    selectOptionsPlain: function() {
      return this.config.selectOptions.map(x => x.name);
    }
  },
  watch: {
    "formData.fair": function(value) {
      this.currentFair = this.config.selectOptions.find(function(obj) {
        return obj.name === value;
      });
    }
  },
  mounted() {
    this.formData.fair = this.initialValue;
  },
  methods: {
    handleSubmit() {
      this.serverError = false;
      this.$v.$touch();
      this.isSubmitted = true;
      this.formSubmitSwitch = !this.formSubmitSwitch;
      if (!this.$v.$invalid) {
        this.executeSwitch = !this.executeSwitch;
      } else {
        this.previousData = JSON.parse(JSON.stringify(this.formData));
      }
    },
    submit(token) {
      this.formData.formId = this.currentFair.formId;
      this.formData.token = token;
      this.formData.domain = window.location.origin;
      this.formData.pageUrl = window.location.pathname;
      this.formData.language = window.currentLanguage;
      this.formData.country = window.currentCountry;
      axios({
        url: window.exhibitionFormUrl,
        method: "post",
        data: this.formData,
        responseType: "json"
      })
        .then(response => {
          if (response.status === 200) {
            window.open(this.config.thankyouUrl, "_self");
          } else {
            this.serverError = true;
          }
        })
        .catch(error => {
          this.serverError = true;
          console.error(error);
        });
    },
    getParameter(param) {
      var params = window.location.search.substr(1).split("&");

      for (var i = 0; i < params.length; i++) {
        var p = params[i].split("=");
        if (p[0] == param) {
          return decodeURIComponent(p[1]);
        }
      }
      return false;
    }
  }
};
</script>

<style module lang="scss">
@import "./OrderForm.scss";
</style>
